import BannerLogin from "./components/BannerLogin";
import FormLogin from "./components/FormLogin";
import "./styles/Login.scss";

const Login = () => {

  return (
    <div className="flex zal-login " style={{ height: "100vh" }}>
      <BannerLogin />
      <div className="login-form">
        <div className="lf-tabLogin flex justify-content-center">
          <FormLogin />
        </div>
      </div>
    </div>
  );
};

export default Login;
